// type MesIndex = {
//     [key in 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12]: string;
// };

// const mesIndex: MesIndex = {
//     0: "undefined",
//     1: "ENERO",
//     2: "FEBRERO",
//     3: "MARZO",
//     4: "ABRIL",
//     5: "MAYO",
//     6: "JUNIO",
//     7: "JULIO",
//     8: "AGOSTO",
//     9: "SEPTIEMBRE",
//     10: "OCTUBRE",
//     11: "NOVIEMBRE",
//     12: "DICIEMBRE",
// }


const fechaREDECO = (dateString: string | null): string | null => {
    if (dateString === null) return null
    const date = new Date(dateString);
    const day = date.getDate() + 1;
    const month = date.getMonth()+1;
    const year = date.getFullYear();

    const formattedDay = day < 10 ? `0${day}` : day;
    const formattedMonth = month < 10 ? `0${month}` : month;
    console.log(`${formattedDay}/${formattedMonth}/${year}`)
    return `${formattedDay}/${formattedMonth}/${year}`;

};

const getDateToDay = (): string => {
    const today: Date = new Date();
    const day: number = today.getDate();
    const month: number = today.getMonth() + 1;
    const year: number = today.getFullYear();
    const formattedDay: string = day < 10 ? `0${day}` : `${day}`;
    const formattedMonth: string = month < 10 ? `0${month}` : `${month}`;
    const label = `${year}-${formattedMonth}-${formattedDay}`
    return label;
}

// const getDateToDayWithFormat = (): string => {
//     const today: Date = new Date();
//     const day: number = today.getDate();
//     const month: number = today.getMonth() + 1;
//     const year: number = today.getFullYear();
//     const formattedDay: string = day < 10 ? `0${day}` : `${day}`;
//     const formattedMonth: string = month < 10 ? `0${month}` : `${month}`;
//     const label = `${year}-${formattedMonth}-${formattedDay}`
//     return formatDate(label);
// }

const getAnioMes = (): string => {
    const value: string = `${getDateToDay().split("-")[0]}-${getDateToDay().split("-")[1]}`;
    return value;
}

// const castMesToLetter = (mes: string | number): string => { // mes = 20
//     const data: number = Number(mes.toString().split("-")[1]) ?? 0;
//     const anio: string = mes.toString().split("-")[0] ?? "undefined"
//     return mesIndex[data as keyof MesIndex] + " DEL " + anio;

// }

// // const obtenerTrimestre = (): number => {
// //     const fecha: Date = new Date();
// //     const mes = fecha.getMonth(); // Los meses van de 0 (enero) a 11 (diciembre)
// //     return Math.ceil((mes + 1) / 3); // Añadimos 1 porque los meses empiezan en 0
// // }

// const obtenerTrimestre = (fecha: Date | string): number => {
//     let mes: number = 1;
//     if (typeof fecha === typeof "") {
//         fecha = new Date(fecha);
//         mes = fecha.getMonth();
//     }
//     if (typeof fecha === typeof Date) {
//         fecha = new Date();
//         mes = fecha.getMonth();
//     }

//     return Math.ceil((mes + 1) / 3);
// }

const formatDateToText = (dateString: string): string => {
    const meses = [
        "Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio",
        "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"
    ];

    // Convertir la cadena en un objeto Date
    const date = new Date(dateString);

    // Extraer día, mes y año
    const dia = date.getDate() + 1;
    const mes = meses[date.getMonth()];
    const anio = date.getFullYear();

    // Formatear el resultado
    return `Día ${dia} de ${mes} del ${anio}`.toLowerCase();
};

const formatoSimple = (fecha: string): string => {
    const array: string[] = fecha.substring(0, 10).split("-");
    const year = array[0];
    const month = array[1];
    const day = array[2];
    return `${day}/${month}/${year}`;
}

const getNomTrimestre = (): number => {    
    const fecha = new Date(getDateToDay());
    const mes: number = fecha.getMonth(); // Obtiene el mes (0-11)
    return Math.floor(mes / 3) + 1; // Calcula el trimestre
}


const Fecha = {
    getAnioMes,
    getDateToDay,
    fechaREDECO,
    formatDateToText,
    formatoSimple,
    getNomTrimestre,
}

export default Fecha;